import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import HoverableOverlapsTooltip from './HoverableOverlapsTooltip'

export interface OverlapsInfo {
  userNames: string[]
  total: number
}

export const MAX_EMPLOYEE_USER_NAMES = 10

interface Props {
  employeeId: number
  company: OverlapsInfo
  inTeam: OverlapsInfo
}

const teamInfo = (employeeId: number, currentEmployeeId: number) => {
  const information =
    employeeId === currentEmployeeId
      ? i18n.t('time_off.info.are_in_your_team')
      : i18n.t('time_off.info.are_in_their_team')

  return information
}

const labelDependingOnCount = (userNames: string[]) => {
  let label = userNames.join(', ')
  if (userNames.length >= MAX_EMPLOYEE_USER_NAMES) {
    label = `${label}, ...`
  }
  return label
}

const LeaveOverlaps = ({ employeeId, company, inTeam }: Props) => {
  const {
    employee: { id: currentEmployeeId },
  } = useCurrentSession()

  if (!company.total) return null

  return (
    <Text.Normal>
      {i18n.tView('time_off.info.overlaps_with_company', {
        people: (
          <HoverableOverlapsTooltip
            number={company.total}
            label={i18n.tp('common.person', { count: company.total })}
          >
            {labelDependingOnCount(company.userNames)}
          </HoverableOverlapsTooltip>
        ),
      })}
      {!!inTeam.total &&
        i18n.tView('time_off.info.overlaps_with_team', {
          team: (
            <HoverableOverlapsTooltip
              number={inTeam.total}
              label={i18n.tp('common.person', { count: inTeam.total })}
            >
              {labelDependingOnCount(inTeam.userNames)}
            </HoverableOverlapsTooltip>
          ),
          info: <Text.Normal>{teamInfo(employeeId, currentEmployeeId)}</Text.Normal>,
        })}
    </Text.Normal>
  )
}

export default observer(LeaveOverlaps)
